module.exports = __webpack_public_path__ + "static/media/report-icon.ace41180.svg";